function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
export default class GridCell extends Component {
  render() {
    const {
      children,
      className,
      direction,
      fill,
      fit,
      full,
      none,
      width,
      shrink,
      subGrid,
      verticalAlign,
      ...rest
    } = this.props;
    const classes = classnames("ax-grid__cell", {
      [`ax-grid__cell--${verticalAlign}`]: verticalAlign,
      "ax-grid__cell--fill": fill === true,
      "ax-grid__cell--fit": fit === true,
      "ax-grid__cell--full": full === true,
      "ax-grid__cell--none": none === true || width,
      "ax-grid__cell--shrink": shrink === true,
      [`ax-grid__cell--fit--${fit}`]: fit && fit !== true,
      [`ax-grid__cell--fill--${fill}`]: fill && fill !== true,
      [`ax-grid__cell--full--${full}`]: full && full !== true,
      [`ax-grid__cell--none--${none}`]: none && none !== true,
      [`ax-grid__cell--shrink--${shrink}`]: shrink && shrink !== true,
      "ax-grid__cell--sub-grid": subGrid,
      "ax-grid--columns": subGrid && direction === "column"
    }, className);
    const styles = {
      width: width && `${Math.max(0, Math.min(width, 100))}%`
    };
    return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
      className: classes,
      style: styles
    }), children);
  }
}